import React, { useState } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { useHistory } from "react-router-dom";
import CreateSchedule from "../schedules/CreateSchedule";

const ReportTable = (props) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [reportId, setReportId] = useState(null);
  const [pageNumber, setPageNumber] = useState();
  const history = useHistory();

  const renderEditable = (cellInfo) => {
    const data = props.tempReportDefinitions[cellInfo.index];
    return (
      <div className="name-fav-wrapper">
        <div className="name-fav-wrapper__item-name">
          <div
            className="editable-name-div none"
            contentEditable
            id={cellInfo.original.id}
            suppressContentEditableWarning
          />
          <a
            id="table-link"
            href={"report?id=" + cellInfo.original.id}
            title={cellInfo.original.name}
          >
            {data[cellInfo.column.id]}
          </a>
        </div>
      </div>
    );
  };

  const renderProjectEditable = (cellInfo) => {
    const data = props.tempReportDefinitions[cellInfo.index];
    return (
      <div className="name-fav-wrapper">
        <div className="name-fav-wrapper__item-name">
          <div
            className="editable-name-div none"
            contentEditable
            id={cellInfo.original.databaseConnection.project.id}
            suppressContentEditableWarning
          />
          <a
            id="table-link"
            href={"report?id=" + cellInfo.original.id}
            title={cellInfo.original.databaseConnection.project.name}
          >
            {data["databaseConnection"].project.name}
          </a>
        </div>
      </div>
    );
  };

  const editClick = (e) => {
    window.location.href =
      "/report/form?projectId=" +
      props.tempReportDefinitions[e.index].databaseConnection.project.id +
      "&dcid=" +
      props.tempReportDefinitions[e.index].databaseConnection.id +
      "&id=" +
      props.tempReportDefinitions[e.index].id;
  };

  const preDelete = (e) => {
    props.preDelete(e.original.name, e.original.id);
  };

  const chartClick = (e) => {
    window.location.href =
      "/chart?reportId=" + props.tempReportDefinitions[e.index].id;
  };
  const scheduleView = (e) => {
    const _reportId = props.tempReportDefinitions[e.index].id;
    setReportId(_reportId);
    setDialogOpen(true);
  };

  const cloneReportPage = (e) => {
    window.open(
      "/report/form?projectId=" +
        props.tempReportDefinitions[e.index].databaseConnection.project.id +
        "&dcid=" +
        props.tempReportDefinitions[e.index].databaseConnection.id +
        "&id=" +
        props.tempReportDefinitions[e.index].id +
        "&clone=1"
    );
  };

  const showHideSearch = (word) => {
    const filterSearch = document.querySelectorAll(
      ".ReactTable .rt-thead.-filters"
    );
    const tableBody = document.querySelectorAll(".ReactTable .rt-tbody");
    var filterInput = document.querySelectorAll(
      ".show .ReactTable .rt-thead.-filters input"
    );

    filterInput.forEach((inp, ind) => {
      inp.setAttribute("id", `search${ind}`);
    });

    filterSearch.forEach((elem) => {
      filterInput.forEach((inp, ind) => {
        document.getElementById(`search${ind}`).focus();
      });
      if (elem.classList.contains("show")) {
        elem.classList.remove("show");
        tableBody.forEach((el) => {
          el.classList.remove("show-filter-pos");
        });
      } else {
        elem.classList.add("show");
        tableBody.forEach((el) => {
          el.classList.add("show-filter-pos");
        });
      }
    });
  };

  return (
    <div id="table-panel">
      <div className="table-list layout-option-content show" data-layout="list">
        <div className="sub-list show">
          <ReactTable
            data={props.tempReportDefinitions}
            filterable
            defaultFilterMethod={(filter, row) =>
              String(row[filter.accessor]) === filter.value
            }
            previousText="Previous"
            nextText="Next"
            pageText="Page"
            rowsText="Rows"
            noDataText="No Rows Found"
            loadingText="Loading"
            onPageChange={(data) => {
              setPageNumber(data);
            }}
            page={pageNumber ? pageNumber : undefined}
            const
            columns={[
              {
                columns: [
                  {
                    Header: () => (
                      <div className="title-search-wrap">
                        <span>Name</span>
                      </div>
                    ),
                    accessor: "name",
                    filterMethod: (filter, row) =>
                      row[filter.id]
                        .toLowerCase()
                        .startsWith(filter.value.toLowerCase()),
                    Cell: renderEditable,
                    className: "name-column",
                    filterable: false,
                  },
                ],
              },
              {
                columns: [
                  {
                    Header: "Project Name",
                    accessor: "databaseConnection.project.name",
                    filterMethod: (filter, row) =>
                      row[filter.id].startsWith(filter.value),
                    Cell: renderProjectEditable,
                    className: "project-name-column",
                    filterable: false,
                  },
                ],
              },
              {
                columns: [
                  {
                    Header: "Actions",
                    Cell: (props) => {
                      let user = JSON.parse(localStorage.getItem("user"));
                      if (user.role === "ADMIN") {
                        return (
                          <div>
                            <a
                              onClick={() => chartClick(props)}
                              className="action-button"
                            >
                              <i
                                className="fa fa-bar-chart"
                                style={{
                                  width: "30px",
                                  height: "20px",
                                  color: "#0C5DB6",
                                }}
                              ></i>
                              <span className="hover-info">Charts</span>
                            </a>
                            <a
                              onClick={() => {
                                editClick(props);
                              }}
                              className="action-button"
                            >
                              <i
                                className="fa fa-pencil"
                                style={{
                                  width: "30px",
                                  height: "20px",
                                  color: "#0C5DB6",
                                }}
                              ></i>
                              <span className="hover-info">Edit</span>
                            </a>
                            <a
                              onClick={() => preDelete(props)}
                              className="action-button"
                            >
                              <i
                                className="fa fa-trash"
                                aria-hidden="true"
                                style={{
                                  width: "30px",
                                  height: "20px",
                                  color: "#ff0000",
                                }}
                              ></i>
                              <span className="hover-info">Delete</span>
                            </a>
                            <a
                              onClick={() => scheduleView(props)}
                              className="action-button"
                            >
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                                style={{
                                  width: "30px",
                                  height: "20px",
                                  color: "#0C5DB6",
                                }}
                              ></i>
                              <span className="hover-info">Schedule</span>
                            </a>
                            <a
                              onClick={() => cloneReportPage(props)}
                              className="action-button"
                            >
                              <i
                                className="fa fa-clone"
                                aria-hidden="true"
                                style={{
                                  width: "30px",
                                  height: "20px",
                                  color: "#0C5DB6",
                                }}
                              ></i>
                              <span className="hover-info">Copy</span>
                            </a>
                          </div>
                        );
                      } else {
                        return (
                          <div>
                            <a
                              onClick={() => chartClick(props)}
                              className="action-button"
                            >
                              <i
                                className="fa fa-bar-chart"
                                style={{
                                  width: "30px",
                                  height: "20px",
                                  color: "#0C5DB6",
                                }}
                              ></i>
                              <span className="hover-info">Charts</span>
                            </a>
                            <a
                              onClick={() => scheduleView(props)}
                              className="action-button"
                            >
                              <i
                                className="fa fa-calendar"
                                style={{
                                  width: "30px",
                                  height: "20px",
                                  color: "#0C5DB6",
                                }}
                                aria-hidden="true"
                              ></i>
                            </a>
                          </div>
                        );
                      }
                    },
                    className: "action-column",
                    style: {
                      textAlign: "center",
                    },
                    sortable: false,
                    filterable: false,
                    width: 120,
                    maxWidth: 120,
                  },
                ],
              },
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        </div>
      </div>

      <CreateSchedule
        unVisible={() => {
          setDialogOpen(false);
        }}
        visible={dialogOpen}
        reportId={reportId}
      />
    </div>
  );
};

export default ReportTable;
